const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    // 黄工TODO api文档提供了一些额外信息，和产品确认下那些需要显示
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.getBaseInfo()
        },
        getBaseInfo() {
            const zhuanJiaChouQuGuid = this.form.businessKey.split(':')[1]
            this.$request.post(`/transformToAfter/app/expert/extract/queryZjcqBaseInfo`, {
                gcGuid: this.form.gcGuid,
                zjcqGuid: zhuanJiaChouQuGuid,
            }, { showLoading: true }).then((res1) => {
                this.config[1].options.data = {
                    '组建申请名称': res1.data.bdNameDC,
                    '组建申请编号': res1.data.bdBHDC,
                    '采购单位': res1.data.zbRName,
                    '代理机构': res1.data.zbDLName,
                    '项目经理': res1.data.projectManagerName,
                    '联系电话': res1.data.lianXiRenPhone,
                    '评审类型': res1.data.pingShenLeiXing,
                    '评审专家库': res1.data.pingShenZhuanJiaKu,
                    '评委人数': res1.data.pingWeiRenShu,
                    '专家人数': res1.data.zhuanJiaRenShu,
                    '抽取方式': res1.data.chouQuFangShi,
                    '通知方式': res1.data.tongZhiFangShi,
                }
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
